/**
 * 用户展示和操作组件
 * 目前有用在页面头部区域
 */

import pageStyle from "./index.module.less";
import * as service from "@/lib/auth/service";

// 用户头像点击提供的操作
const userOptions = [];

if (process.env.VUE_APP_FUNC_PSWD_REWRITE !== "mask") {
    userOptions.push(
        // eslint-disable-next-line no-undef
        {
            i18n: "all.exit",
            cmd: "logout"
        }
    );
    userOptions.push({
        i18n: "password.resetTitle",
        cmd: "resetPsw"
    });
}

export default {
    name: "User",
    data() {
        return {
            userOptions,
            pageStyle
        };
    },
    methods: {
        handleCommand(command) {
            switch (command) {
                case "logout":
                    service.logout();
                    break;
                case "resetPsw":
                    this.$router.push({ path: "/password/reset" });
                    break;
            }
        }
    }
};
